export const BUTTON_SIZE_MAPS = {
  BIG: 'text-base font-medium h-12 py-1.5 px-3',
  MEDIUM: 'text-base font-medium h-11 py-3 px-4',
  SMALL: 'text-sm font-semibold h-8 py-3 px-4',
  XS: 'text-xs font-semibold h-8 py-2 px-2',
}

export const BUTTON_TYPE_MAPS = {
  PRIMARY:
    'text-gray-50 bg-blue-600 hover:bg-blue-800 active:bg-blue-600 focus:bg-blue-800 disabled:text-white disabled:bg-gray-300 disabled:cursor-not-allowed',
  SECONDARY:
    'text-gray-800 border bg-white border-gray-800 hover:bg-gray-100 focus:bg-gray-100 hover:text-black disabled:bg-white disabled:text-gray-400 disabled:border-gray-400 disabled:cursor-not-allowed',
  SECONDARY_BLUE:
    'text-blue-500 border border-blue-500 cursor-pointer bg-white hover:bg-blue-50  disabled:bg-white disabled:text-gray-400 disabled:border-gray-400 disabled:cursor-not-allowed',
  APPROVED: 'text-white bg-emerald-500 hover:bg-emerald-300',
  RED: 'text-gray-50 bg-red-600 hover:bg-red-800 active:bg-red-600 focus:bg-red-800 disabled:text-white disabled:bg-gray-300 disabled:cursor-not-allowed',
}
